/** Экран без права: словами, у кого просить, а не пустота и не ошибка. */
export function NoAccess({ what }: { what: string }) {
  return (
    <main className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-4 [&>*]:flex-none">
      <div className="rounded-[var(--radius-card)] border border-border bg-bg-subtle p-4 text-[13px] text-fg-muted">
        Нет доступа к {what}. Права выдаёт тот, кто управляет полномочиями, — «Настройки → Полномочия».
      </div>
    </main>
  );
}
